import { MdsIconKind } from "@/design-system/components/icon";
import {
  StyledIcon,
  StyledInner,
  StyledText,
  StyledChipButton,
  StyledRemoveButton,
} from "./chip.style";
import { ChipVariant, MDSChipProps } from "./chip.types";

export const MDSChip = (props: MDSChipProps) => {
  const {
    iconKind,
    icon,
    children,
    maxWidth,
    color = "default",
    variant = ChipVariant.Default,
    onRemove,
    ...rest
  } = props;

  return (
    <StyledChipButton $color={color} $variant={variant} {...rest} data-mds-name="chip">
      <StyledInner maxWidth={maxWidth}>
        {!icon && iconKind && <StyledIcon kind={iconKind} $variant={variant} />}
        {icon}
        <StyledText $variant={variant}>{children}</StyledText>
        {onRemove && <StyledRemoveButton onClick={onRemove} iconKind={MdsIconKind.Exit} />}
      </StyledInner>
    </StyledChipButton>
  );
};
